import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import { Delete, Edit, Print } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import CustomPagination from "../../../../../components/custom-pagination/CustomPagination";
import { AppMisc } from "../../../../../misc/appMisc";
import { AppUtils } from "../../../../../utils/appUtils";
import { NO_RECORDS_FOUND } from "../../../../../utils/constants";

const SwarnaBinduPradarshanRegisterTable = ({ totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      setMainRegisterData(props.tableData);
    }
  }, [props.tableData]);

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => tableRef.current}
      />
      <TableContainer classes={{ root: "fixed-head-table-container" }}>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Swarna Bindu Pradarshan Register" ref={tableRef}>
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={2}>क्र.सं</TableCell>
              <TableCell rowSpan={2}>दर्ता मिति</TableCell>
              <TableCell colSpan={3}>६ महिनादेखि १ वर्षसम्म</TableCell>
              <TableCell colSpan={3}>१ वर्षदेखि २ वर्षसम्म</TableCell>
              <TableCell colSpan={3}>२ वर्षदेखि ५ वर्षसम्म</TableCell>
              <TableCell rowSpan={2}>कुल जम्मा</TableCell>
              <TableCell rowSpan={2} className="print-none">सम्पादन</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>बालक</TableCell>
              <TableCell>बालिका</TableCell>
              <TableCell>जम्मा</TableCell>
              <TableCell>बालक</TableCell>
              <TableCell>बालिका</TableCell>
              <TableCell>जम्मा</TableCell>
              <TableCell>बालक</TableCell>
              <TableCell>बालिका</TableCell>
              <TableCell>जम्मा</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {mainRegisterData?.length > 0 ? (
              mainRegisterData.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                  <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                  <TableCell>{row?.maleSixToElevenMonths ? AppUtils.replaceWithNepaliDigit(row.maleSixToElevenMonths) : "-"}</TableCell>
                  <TableCell>{row?.femaleSixToElevenMonths ? AppUtils.replaceWithNepaliDigit(row.femaleSixToElevenMonths) : "-"}</TableCell>
                  <TableCell>{row?.totalChildrenSixToElevenMonths ? AppUtils.replaceWithNepaliDigit(row.totalChildrenSixToElevenMonths) : "-"}</TableCell>
                  <TableCell>{row?.maleOneToTwoYears ? AppUtils.replaceWithNepaliDigit(row.maleOneToTwoYears) : "-"}</TableCell>
                  <TableCell>{row?.femaleOneToTwoYears ? AppUtils.replaceWithNepaliDigit(row.femaleOneToTwoYears) : "-"}</TableCell>
                  <TableCell>{row?.totalChildrenOneToTwoYears ? AppUtils.replaceWithNepaliDigit(row.totalChildrenOneToTwoYears) : "-"}</TableCell>
                  <TableCell>{row?.maleTwoToFiveYears ? AppUtils.replaceWithNepaliDigit(row.maleTwoToFiveYears) : "-"}</TableCell>
                  <TableCell>{row?.femaleTwoToFiveYears ? AppUtils.replaceWithNepaliDigit(row.femaleTwoToFiveYears) : "-"}</TableCell>
                  <TableCell>{row?.totalChildrenTwoToFiveYears ? AppUtils.replaceWithNepaliDigit(row.totalChildrenTwoToFiveYears) : "-"}</TableCell>
                  <TableCell>{row?.totalChildren ? AppUtils.replaceWithNepaliDigit(row.totalChildren) : "-"}</TableCell>
                  <TableCell className="print-none">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                        <Edit fontSize="small" />
                      </IconButton>
                      <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                        <IconButton onClick={() => props.deleteRow(row.id)}>
                          <Delete fontSize="small" color='secondary' />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan="13" size="medium">{NO_RECORDS_FOUND}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination count={totalSize} />
    </>
  );
};

export default SwarnaBinduPradarshanRegisterTable;
